/*--------------------------------------------------------------------------------------------------------------
 *  Copyright (c) insite-gmbh. All rights reserved.
 *  Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------------------------*/
import { NgModule } from '@angular/core';
import { InaxTranslatePipe } from './pipe';

@NgModule({
    exports:
    [
        InaxTranslatePipe
    ],
    declarations:
    [
        //Components
        InaxTranslatePipe
    ]
})

export class TranslateModule { }